'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../i-bem/i-bem.react');

var _bIconMGlyphTypeTick = (require('./../../icon/icon.react.js'), require('./../../icon/_glyph/icon_glyph.react.js'), (require('./../../icon/_glyph/icon_glyph_type-tick.react.js').default || require('./../../icon/_glyph/icon_glyph_type-tick.react.js')).applyDecls());

var _bIconMGlyphTypeTick2 = _interopRequireDefault(_bIconMGlyphTypeTick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'checkbox',
    elem: 'tick',
    tag: 'i',
    content: function content(_ref) {
        var view = _ref.view,
            size = _ref.size;

        if (view === 'classic') {
            return;
        }

        return _react2.default.createElement(_bIconMGlyphTypeTick2.default, { glyph: 'type-tick' });
    }
});